import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import {Dropdown, Toggle} from "@fluentui/react";

function AddPerson(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [personalId, setPersonalId] = useState('');
    const [address, setAddress] = useState('');
    const [parents, setParents] = useState('');
    const [marketing, setMarketing] = useState(true);
    const [source, setSource] = useState('');
    const [sourceList, setSourceList] = useState([]);
    const [accountManager, setAccountManager] = useState(null);
    const [sales, setSales] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            surname: surname,
            marketing: marketing,
            source: source.key,
            account_manager_id:
            accountManager.key,
            phone: phone,
            email: email,
            personal_id: personalId,
            address: address,
            parents: parents
        };
        fetch(`/api/person`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddPerson'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setName('');
            setSurname('');
            setSource('');
            setAccountManager('');
            setMarketing(true);
            setPhone('');
            setEmail('');
            setPersonalId('');
            setAddress('');
            setParents('');

            async function fetchSales() {
                await fetch(`/api/user/sales`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setSales(data.map((item) => {
                            return {key: item.id, text: `${item.name} ${item.surname}`};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }

            fetchSales();

            async function fetchSources() {
                await fetch(`/api/acquisition`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setSourceList(data.map((item) => {
                            return {key: item, text: item};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }

            fetchSources();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Osobę"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddPerson'>
                <TextField required autoFocus label='Imię' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField required label='Nazwisko' value={surname} onChange={(e) => setSurname(e.target.value || '')}/>
                <Dropdown
                    label="Miejsce Pozyskania"
                    selectedKey={source ? source.key : undefined}
                    onChange={(e, item) => setSource(item)}
                    placeholder="Wybierz z listy"
                    options={sourceList}
                />
                <Dropdown
                    label="Opiekun"
                    selectedKey={accountManager ? accountManager.key : undefined}
                    onChange={(e, item) => setAccountManager(item)}
                    placeholder="Wybierz z listy"
                    options={sales}
                />
                <TextField label='Telefon' value={phone} onChange={(e) => setPhone(e.target.value || '')}/>
                <TextField label='Email' value={email} onChange={(e) => setEmail(e.target.value || '')}/>
                <TextField label='Pesel' value={personalId} onChange={(e) => setPersonalId(e.target.value || '')}/>
                <TextField label='Rodzice' value={parents} onChange={(e) => setParents(e.target.value || '')}/>
                <TextField label='Adres' value={address} onChange={(e) => setAddress(e.target.value || '')}/>
                <Toggle label="Zgoda Marketingowa" defaultChecked onText="Tak" offText="Nie" onChange={(e, checked) => setMarketing(checked)} />
            </form>
        </Panel>
    )
}

export default AddPerson;